/** SBOM import, demo generation and continuous Dependency-Track sync. */
import { useEffect, useState, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Banner } from '../../components/Banner';
import { errorMessage, fetchChangeStatus } from '../../lib/api';
import { useAuth } from '../../lib/auth';
import XDomeSbomCard from '../admin/XDomeSbomCard';

export function SystemSbomPage(): ReactNode {
  const { has } = useAuth();
  const [status, setStatus] = useState<Awaited<ReturnType<typeof fetchChangeStatus>> | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let active = true;
    let timer: ReturnType<typeof setTimeout>;
    async function refresh(): Promise<void> {
      try {
        const next = await fetchChangeStatus();
        if (active) { setStatus(next); setError(null); }
      } catch (err) {
        if (active) setError(errorMessage(err));
      } finally {
        if (active) timer = setTimeout(() => void refresh(), 5000);
      }
    }
    void refresh();
    return () => { active = false; clearTimeout(timer); };
  }, []);
  return (
    <>
      <XDomeSbomCard />
      {has('import.write') ? (
        <div className="card">
          <div className="card-head"><h2>SBOM in Stammdaten übernehmen</h2></div>
          <div className="card-body">
            <p>CycloneDX-JSON hochladen und Komponenten sowie enthaltene Demo-Maschinen, Kunden und Auslieferungen in CMDBuild übernehmen.</p>
            <Link to="/import">SBOM importieren</Link>
          </div>
        </div>
      ) : null}
      <div className="card">
        <div className="card-head"><h2>Automatischer Dependency-Track-Sync</h2></div>
        <div className="card-body">
          <p>Neue und geänderte ausgelieferte Maschinen werden automatisch an Dependency-Track übertragen,
            ebenso Änderungen an ihren Komponenten und Stücklisten.</p>
          <p>Änderungen aus der Oberfläche und aus Importen starten den Abgleich automatisch. Direkte Änderungen
            in CMDBuild werden im Abstand von 60 Sekunden geprüft, beim Serverstart der gesamte Bestand.</p>
          <div aria-live="polite">
            {error ? <Banner kind="error">Sync-Status nicht verfügbar: {error}</Banner> :
              !status ? <p>Status wird geladen…</p> :
              status.poll_failed ? <Banner kind="warn">CMDBuild konnte nicht geprüft werden. Die Prüfung wird automatisch wiederholt.</Banner> :
              status.failed ? <Banner kind="warn">Übertragung fehlgeschlagen; automatischer Wiederholungsversuch folgt. Bisherige Versuche: {status.attempts}.</Banner> :
              <p>{status.pending ? 'Änderungen warten auf Übertragung oder werden verarbeitet.' : 'Automatik aktiv · keine Übertragung ausstehend.'}</p>}
          </div>
          <p className="muted">Je ausgelieferte Maschine entsteht ein Projekt in Dependency-Track. Produkte ohne Auslieferung oder ohne auflösbare Komponenten werden nicht übertragen.</p>
        </div>
      </div>
    </>
  );
}
export default SystemSbomPage;
